<template>
  <svg width="7" height="8" viewBox="0 0 7 8" xmlns="http://www.w3.org/2000/svg" :class="directionTransformation">
    <path
        d="M2.83911 0.449691L2.84199 0.437203L2.84199 5.79044L1.06525 4.10758C0.978505 4.02517 0.860997 3.97997 0.737664 3.97997C0.614332 3.97997 0.497646 4.02517 0.410697 4.10758L0.134706 4.36943C0.0479626 4.45177 4.48946e-08 4.5615 4.33669e-08 4.6785C4.18384e-08 4.79558 0.0476201 4.90536 0.134364 4.98771L3.17307 7.87245C3.26015 7.95512 3.37615 8.00032 3.49955 8C3.62364 8.00032 3.73971 7.95512 3.82666 7.87245L6.86564 4.98771C6.95231 4.90537 7 4.79564 7 4.6785C7 4.5615 6.95224 4.45177 6.86564 4.36943L6.58965 4.10758C6.50304 4.02517 6.38738 3.97997 6.26405 3.97997C6.14079 3.97997 6.03122 4.02517 5.94455 4.10758L4.15788 5.80943L4.15788 0.443708C4.15788 0.202601 3.93896 4.29007e-08 3.6851 4.01359e-08L3.29475 3.58845e-08C3.0409 3.31196e-08 2.83911 0.208586 2.83911 0.449691Z"
        fill="currentColor"/>
  </svg>
</template>

<script>
export default {
  name: "IconArrow",
  props: {
    direction: {
      type: String,
      default: 'down'
    }
  },
  computed: {
    directionTransformation() {
      switch (this.direction) {
        case 'up' :
          return 'transform rotate-180'
        case 'left' :
          return 'transform rotate-90'
        case 'right':
          return 'transform -rotate-90'
        default:
          return ''
      }
    }
  }
}
</script>